import React from 'react';
import { useQuery } from '../../graphQL/useQuery';
import HelpTooltip from '../utilityBarItems/HelpTooltip';
import Dropdown, {
  OtherProps as NonLoadingDropdownProps,
} from './Dropdown';
import {
  query,
  SuccessResponse,
  transform,
  variables,
  Variables,
} from './query';

type Props = NonLoadingDropdownProps & {
  helpTooltipIndex: number;
  isHelpActive: boolean;
};

export default (props: Props) => {
  let output: React.ReactElement<any> | null;
  const {loading, error, data} = useQuery<SuccessResponse, Variables>(query, {variables});
  const {
    selectedCountry, onCountrySelect, promptText,
    visualProps, useTriggerButton, getFluentString,
  } = props;
  if (loading === true) {
    output = (
      <Dropdown
        isLoading={true}
        selectedCountry={selectedCountry}
        onCountrySelect={onCountrySelect}
        promptText={promptText}
        getFluentString={getFluentString}
        visualProps={visualProps}
        useTriggerButton={useTriggerButton}
      />
    );
  } else if (error !== undefined) {
    output = null;
    console.error(error);
  } else if (data !== undefined) {
    const countryDropdown = [...data.countryDropdown];
    const transformed = transform(countryDropdown);
    output = (
      <Dropdown
        isLoading={false}
        options={transformed}
        selectedCountry={selectedCountry}
        onCountrySelect={onCountrySelect}
        promptText={promptText}
        getFluentString={getFluentString}
        visualProps={visualProps}
        useTriggerButton={useTriggerButton}
      />
    );
  } else {
    output = null;
  }
  const { helpTooltipIndex, isHelpActive } = props;
  return (
    <>
      {output}
      <HelpTooltip
        index={helpTooltipIndex}
        term={getFluentString('help-tooltips-search-title')}
        explanation={getFluentString('help-tooltips-search-description')}
        isHelpActive={isHelpActive}
        styles={{}}
      />
    </>
  );
};
